import { Outlet, createRootRoute } from "@tanstack/react-router";

import { AppLoading } from "@/shared/components/app-loading";
import { NotFoundPage } from "@/shared/components/not-found-page";
import { useAppPageTracking } from "@/shared/hooks/use-page-tracking";

export const Route = createRootRoute({
  component: () => Root(),
  notFoundComponent: () => NotFoundPage()
});

const Root = () => {
  useAppPageTracking();
  return (
    <AppLoading>
      <div className="bg-background-primary fixed top-0 left-0 w-full h-full z-[-1]" />
      <div className="relative flex flex-col h-screen w-full">
        <Outlet />
      </div>
    </AppLoading>
  );
};
